import type {Message} from '@cohort/wallet-schemas/iframeMessage';

export default function sendMessageToParent(message: Message): void {
  window.parent.postMessage(message, '*');
}
